import { render, staticRenderFns } from "./processing-status-users-detail.view.vue?vue&type=template&id=15005ae0&"
import script from "./processing-status-users-detail.view.vue?vue&type=script&lang=ts&"
export * from "./processing-status-users-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports